import React from 'react';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import {
  DropDownChonPhongBanThuocCoQuan,
  DropDownChonKetQuaThucHien,
  DropDownChonCanBoGiaiQuyet,
  DropDownMulipleUse,
  DropDownChonKetQuaGiaiQuyet,
  DropDownChonKetLuanNoiDungKhieuNai
} from 'components/tt-forms';
import moment from 'moment';
import { GiaiQuyetDonThu, DuLieuHeThong } from 'api';
import { Link } from 'react-router';
import { ShowIf } from 'components/utils';
import { msg } from 'constants/message';
import ConfirmDialog from './ConfirmDialog.jsx';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import { Input, TextMessage, TextArea, InputNumber } from 'components/tt-forms/common';
import {BlockGiaiQuyetDonInfo, BlockBanHanhQuyetDinhView} from 'modules/giai-quyet-don/subView';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class TruongPhongNhanYeuCauTheoDoiThucHien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      focused: false,
      dataDetail: [],
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      dataCoQuanTheoDoi: [],
      dataNextStates: [],
      dataCongChuc: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],

      dataTaiLieuVanThuGiaiQuyetDon: this.props.listTaiLieuVanThuGiaiQuyetDon,

      id: this.props.id,
      loaiDon: this.props.loaiDon,
      nextState: '',
      khoiToInit: '',
      soVuBiKhoiToInit: '',
      soDoiTuongBiKhoiToInit: '',
      khoiTo : false,
      openDialog:false,
      soVuBiKhoiTo : 0,
      soDoiTuongBiKhoiTo : 0,
      hinhThucTheoDoi : '',
      coQuanTheoDoi : '',
      ketQuaThucHienTheoDoi : '',
      ketQuaThucHienKhac : '',
      tienPhaiThuNhaNuoc : 0,
      datPhaiThuNhaNuoc : 0,
      tienDaThuNhaNuoc : 0,
      datDaThuNhaNuoc : 0,
      tienPhaiTraCongDan : 0,
      datPhaiTraCongDan : 0,
      tienDaTraCongDan : 0,
      datDaTraCongDan : 0,
      canBoXuLyChiDinh: '',
      getDetail: false,
      getCongChucPhongBan: false,
      checkState: false,
      textNextState: '',
      ketQuaGiaiQuyetLan2: '',
      soLanGiaiQuyetLai: '',
      noiDungKetLuanGiaiQuyetLai: '',
      soVuGiaiQuyetKhieuNai: '',
      ketLuanNoiDungKhieuNai: '',
      ketQuaGiaiQuyetKhac: '',
      tienPhaiThuNhaNuocQDGQ: '',
      datPhaiThuNhaNuocQDGQ: '',
      tienPhaiTraCongDanQDGQ: '',
      datPhaiTraCongDanQDGQ: '',
      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',
      soNguoiDuocTraLaiQuyenLoi: '',
      nguoiBanHanh: '',
      phongBanChiDinh: ''
    }
  }

  componentDidMount() {
    this.getCoQuanTheoDoiEnumn();
    this.getDetail(this.state.thongTinGiaiQuyetDonId);
    if(this.props.dataNextStates.length > 0) {
      this.filterState(this.props.dataNextStates);
    }
    if(this.state.coQuanQuanLyNguoiDung && this.state.coQuanQuanLyNguoiDung.id) {
      this.getCongChucPhongBan(this.state.coQuanQuanLyNguoiDung.id)
    }
    if (window.debug) {
      console.log('giai-quyet-don/subView/TruongPhongNhanYeuCauTheoDoiThucHien');
    }
  }

  getCongChucPhongBan(id) {
    let params = {
      coQuanQuanLyId: id,
      vaiTro: 'CHUYEN_VIEN',
      page: 0,
      size: 1000,
      sort: 'ten,desc'
    }

    DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request(params).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataCongChuc: res.data._embedded.congChucs
        }, () => {
          this.setState({
            getCongChucPhongBan: true
          })
        });
      }
    });
  }

  filterState(data) {
    let dataNextStates = [];
    let getGiaoPhongBan = [...data].filter(item => item.type === "NHANTDTH_GIAO_PHONG_CUNG_CAP");
    if (getGiaoPhongBan.length) {
      let phoPhong = {
        stateId : getGiaoPhongBan[0].stateId,
        ten: "Trưởng phòng giao việc phó phòng",
        tenVietTat: "Giao việc phó phòng",
        type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
      }
      data.push(phoPhong);
    }
    data.map(item => {
      let Item = {
        ...item
      }
      if(Item.type == "CAN_BO_TDTH_LUU_DON" || Item.type == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
        Item.tenVietTat = 'Tự xử lý'
      }
      dataNextStates[dataNextStates.length] = Item
    })
    this.setState({
      dataNextStates: dataNextStates
    })
  }

  getDetail(id) {
    if (typeof id != 'undefined') {
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({id:id}).then(res => {
        if (res.data) {
          this.setState({
            dataDetail: res.data,
            khoiToInit: res.data.khoiTo,
            soVuBiKhoiToInit: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiToInit: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
            phongBanChiDinh: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
            canBoXuLyChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : (res.data.nextStateInfo ? res.data.nextStateInfo.type : ''),
            showFile: false,
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : '',
            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,
          },()=> {
            if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
              this.checkFileDinhKem();
            } else {
              this.filterFileDinhKem();
            }
            this.setState({
              getDetail: true
            })
          })
        }
      })
    }
  }

  filterFileDinhKem() {
    let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
      return state.typeRequired != 'DON_VI_THEO_DOI_THUC_HIEN';
    })
    this.setState({
      listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon
    }, () => {
      this.setState({
        showFile: true
      })
    })
  }

  checkFileDinhKem() {
    let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let dataView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), 'action');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = dataView.filter(state => {
      return this.compareDate(new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
    })
    this.setState({
      listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
      listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView
    } , () => {
      this.setState({
        showFile: true
      })
    })
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()
    if (firstTime > secondTime || (firstTime == secondTime && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.id,
      coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung,
      loaiDon: nextProps.loaiDon
    })
    if (this.props.listTaiLieuVanThuGiaiQuyetDon != nextProps.listTaiLieuVanThuGiaiQuyetDon) {
      this.setState({
        dataTaiLieuVanThuGiaiQuyetDon: nextProps.listTaiLieuVanThuGiaiQuyetDon
      })
    }
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.props.handleChangeData();
  }

  onChange(name, e) {
    if (name == 'nextState') {
      let data = [...this.state.dataTaiLieuVanThuGiaiQuyetDon];
      let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
        return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
      })
      if (listTaiLieuVanThuGiaiQuyetDon.length > 0 || this.state.dataFileDinhKem.length > 0) {
        this.resetData();
        this.setState({
          confirm: true,
          textNextState: e.target.value
        })
      } else {
        this.setState({
          [name]: e.target.value,
          showFile: false
        }, ()=> {
          this.resetData();
          if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
            this.checkFileDinhKem();
          } else {
            this.filterFileDinhKem();
          }
        })
      }
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
    if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
      this.setState({
        noiDungKetLuanGiaiQuyetLai: ''
      })
    }
    this.props.handleChangeData();
  }

  onConfirm() {
    this.setState({
      confirm: false,
      dataFileDinhKem: [],
      nextState: this.state.textNextState,
      showFile: false
    }, () => {
      this.resetData();
      if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
        this.checkFileDinhKem();
      } else {
        this.filterFileDinhKem();
        let data = [...this.state.dataTaiLieuVanThuGiaiQuyetDon];
        let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
          return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
        })
        let dataFilter = [...this.state.dataTaiLieuVanThuGiaiQuyetDon];
        let listTaiLieuVanThuGiaiQuyetDonFilter = []
        listTaiLieuVanThuGiaiQuyetDonFilter = dataFilter.filter(state => {
          return state.typeRequired != 'DON_VI_THEO_DOI_THUC_HIEN';
        })

        if (listTaiLieuVanThuGiaiQuyetDon.length > 0) {
          listTaiLieuVanThuGiaiQuyetDon.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if(this.state.taiLieuVanThuDelete.length > 0) {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {});
          this.setState({
            dataTaiLieuVanThuGiaiQuyetDon:listTaiLieuVanThuGiaiQuyetDonFilter,
            taiLieuVanThuDelete: [],

          })
        }
      }
    })
  }

  resetData() {
    this.setState({
      khoiTo: this.state.khoiToInit,
      soVuBiKhoiTo: this.state.soVuBiKhoiToInit,
      soDoiTuongBiKhoiTo: this.state.soDoiTuongBiKhoiToInit,
      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',
      ketQuaThucHienKhac: '',
      tienPhaiThuNhaNuoc: 0,
      datPhaiThuNhaNuoc: 0,
      tienDaThuNhaNuoc: 0,
      datDaThuNhaNuoc: 0,
      tienPhaiTraCongDan: 0,
      datPhaiTraCongDan: 0,
      tienDaTraCongDan: 0,
      datDaTraCongDan: 0,
      canBoXuLyChiDinh: ''
    })
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    });
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
    this.props.handleChangeData();
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    });
    this.handleKetThuc();
  }

  getParams() {
    let dataGQD = this.state.dataDetail;
    let params = getParams(dataGQD, this.state.id);

    if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON') {
      if(params.giaoCoQuanDieuTra && this.state.khoiTo) {
        params.khoiTo = true;
        params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
        params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
      } else {
        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }
    }

    params.theoDoiThucHien = true;
    params.hinhThucTheoDoi = this.state.hinhThucTheoDoi ? this.state.hinhThucTheoDoi : null;
    if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
      params.coQuanTheoDoi = this.state.coQuanTheoDoi ? this.state.coQuanTheoDoi : null;
    } else {
      params.coQuanTheoDoi = null;
    }
    params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi ? this.state.ketQuaThucHienTheoDoi : null;
    params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac ? this.state.ketQuaThucHienKhac : '';

    params.tienPhaiThuNhaNuoc = this.state.tienPhaiThuNhaNuoc ? Number(this.state.tienPhaiThuNhaNuoc) : 0;
    params.datPhaiThuNhaNuoc = this.state.datPhaiThuNhaNuoc ? Number(this.state.datPhaiThuNhaNuoc) : 0;
    params.tienPhaiTraCongDan = this.state.tienPhaiTraCongDan ? Number(this.state.tienPhaiTraCongDan) : 0;
    params.datPhaiTraCongDan = this.state.datPhaiTraCongDan ? Number(this.state.datPhaiTraCongDan) : 0;

    params.tienDaThuNhaNuoc = this.state.tienDaThuNhaNuoc ? Number(this.state.tienDaThuNhaNuoc) : 0;
    params.datDaThuNhaNuoc = this.state.datDaThuNhaNuoc ? Number(this.state.datDaThuNhaNuoc) : 0;
    params.tienDaTraCongDan = this.state.tienDaTraCongDan ? Number(this.state.tienDaTraCongDan) : 0;
    params.datDaTraCongDan = this.state.datDaTraCongDan ? Number(this.state.datDaTraCongDan) : 0;

    let selectedState = this.state.dataNextStates.filter(state => {
      return state.type == this.state.nextState
    });

    if (selectedState.length > 0) {
      params.nextState = {
        id: selectedState[0].stateId
      }
    } else {
      params.nextState = null
    }

    if (this.state.canBoXuLyChiDinh) {
      params.canBoXuLyChiDinh = {
        id: Number(this.state.canBoXuLyChiDinh)
      }
    } else {
      params.canBoXuLyChiDinh = null
    }

    if (this.state.phongBanChiDinh) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanChiDinh)
      };
    }

    if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
      params.phoPhong = true;
    } else {
      params.phoPhong = false;
    }

    let isQDGQ = dataGQD.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET';
    params.soLanGiaiQuyetLai = (isQDGQ && this.props.loaiDon == 'DON_KHIEU_NAI') ? Number(this.state.soLanGiaiQuyetLai) : 0;
    params.ketQuaGiaiQuyetLan2 = Number(this.state.soLanGiaiQuyetLai) > 1 ?  this.state.ketQuaGiaiQuyetLan2 : null;
    params.noiDungKetLuanGiaiQuyetLai = (this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I') ? this.state.noiDungKetLuanGiaiQuyetLai : '';
    params.soVuGiaiQuyetKhieuNai = isQDGQ ? Number(this.state.soVuGiaiQuyetKhieuNai) : 0;
    params.ketLuanNoiDungKhieuNai = isQDGQ ? this.state.ketLuanNoiDungKhieuNai : null;
    params.ketQuaGiaiQuyetKhac = isQDGQ ? this.state.ketQuaGiaiQuyetKhac : '';
    params.tienPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.tienPhaiThuNhaNuocQDGQ) : 0;
    params.datPhaiThuNhaNuocQDGQ = isQDGQ ? Number(this.state.datPhaiThuNhaNuocQDGQ) : 0;
    params.tienPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.tienPhaiTraCongDanQDGQ) : 0;
    params.datPhaiTraCongDanQDGQ = isQDGQ ? Number(this.state.datPhaiTraCongDanQDGQ) : 0;
    params.tongSoNguoiXuLyHanhChinh = isQDGQ ? Number(this.state.tongSoNguoiXuLyHanhChinh) : 0;
    params.soNguoiDaBiXuLyHanhChinh = isQDGQ ? Number(this.state.soNguoiDaBiXuLyHanhChinh) : 0;
    params.soNguoiDuocTraLaiQuyenLoi = isQDGQ ? Number(this.state.soNguoiDuocTraLaiQuyenLoi) : 0;
    params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
    return params;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  handleKetThuc() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });
      if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
        let dataFileDinhKem = [...this.state.dataFileDinhKem];
        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
              };
            }
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }
      } else {
        let data = [...this.state.dataTaiLieuVanThuGiaiQuyetDon];
        let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
          return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
        })

        if (listTaiLieuVanThuGiaiQuyetDon.length > 0) {
          listTaiLieuVanThuGiaiQuyetDon.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
      }

      let _params = this.getParams();
      let selectedState = this.state.dataNextStates.filter(state => {
          return state.type == this.state.nextState
      });
      let params = {
        thongTinGiaiQuyetDon: {
          id: Number(this.props.thongTinGiaiQuyetDonId),
        },
        nextState: {
          id: Number(selectedState[0].stateId),
        },
      };
      let msgName = '';
      if(this.state.canBoXuLyChiDinh) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoXuLyChiDinh)
        }
        msgName = 'gqdGiaoViec';
      } else {
        msgName = 'gqdLuuHoSo';
      }
      if(this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG') {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.coQuanQuanLyNguoiDung.id)
        };
        params.phoPhong = true;
      }
      if (this.state.nextState === 'NHANTDTH_GIAO_PHONG_CUNG_CAP') {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanChiDinh)
        };
      }
      if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          });
        });
      } else {
        this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
          this.props.updateGiaiQuyetDon(_params, params, msgName);
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.truongPhongThuHoi == true) {
      if (this.select && prevState.focused == false) {
        this.setState({
          focused: true
        })
        this.select.focus();
      }
    }
    if (this.state.getCongChucPhongBan == true && this.state.getDetail == true && this.state.checkState == false) {
      if (this.state.dataDetail.huongThuLyGiaiQuyet == 'TU_TTXM') {
        if (this.state.nextState) {
          // do nothing
          this.setState({
            checkState: true
          })
        } else if(this.state.dataCongChuc.length == 0 || this.props.truongPhongThuHoi == true) {
          this.setState({
            nextState: 'CAN_BO_PHONG_TDTH_LUU_HO_SO',
            checkState: true
          })
        } else if (this.props.dataNextStates.length > 1) {
          this.setState({
            nextState: 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO',
            checkState: true
          })
        } else if (this.props.dataNextStates.length == 1) {
          this.setState({
            nextState: this.state.dataNextStates[0].type,
            checkState: true
          })
        }
      } else {
        if (this.state.nextState) {
          // do nothing
          this.setState({
            checkState: true
          })
        } else if(this.state.dataCongChuc.length == 0 || this.props.truongPhongThuHoi == true) {
          this.setState({
            nextState: 'CAN_BO_TDTH_LUU_DON',
            checkState: true
          }, () => {
            this.checkFileDinhKem();
          });
        } else if (this.props.dataNextStates.length > 1) {
          this.setState({
            // nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO',
            checkState: true
          })
        } else if (this.props.dataNextStates.length == 1) {
          this.setState({
            nextState: this.state.dataNextStates[0].type,
            checkState: true
          })
        }
      }
    }
  }

  handleSave() {
    this.setState({
      btnLoading: true,
      btnSaveLoading: true
    });
    if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
      let dataFileDinhKem = [...this.state.dataFileDinhKem];
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }
    } else {
      let data = [...this.state.dataTaiLieuVanThuGiaiQuyetDon];
      let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
        return state.typeRequired == 'DON_VI_THEO_DOI_THUC_HIEN';
      })

      if (listTaiLieuVanThuGiaiQuyetDon.length > 0) {
        listTaiLieuVanThuGiaiQuyetDon.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }
    }

    let params = this.getParams();
    params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
    if(this.state.nextState == 'CAN_BO_TDTH_LUU_DON' || this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') {
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        });
      });
    } else {
      this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
        this.props.saveGiaiQuyetDon(params, 'gqdLuu');
      });
    }
  }

  onFileChange(data, type) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    this.setState ({
      dataFileDinhKem: data
    });

    this.props.handleChangeData();

  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  render() {
    let {nextState, dataDetail} = this.state;
    let ketLuanNDKhieuNaiLabel = this.props.loaiDon == 'DON_KHIEU_NAI' ? 'Kết luận nội dung khiếu nại' : (this.props.loaiDon == 'DON_TO_CAO' ? 'Kết luận nội dung tố cáo' : "Kết luận nội dung kiến nghị phản ánh");
    let labelQD = this.props.loaiDon == 'DON_TO_CAO' ? 'Quyết định giải quyết tố cáo' : (this.props.loaiDon == 'DON_KHIEU_NAI' ? 'Quyết định giải quyết khiếu nại' : 'Văn bản giải quyết kiến nghị, phản ánh');
    let dk1 = (nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') && dataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET';
    return (
      <section className="wrap-block">
        {
          dataDetail.donViGiaoThamTraXacMinhInfo != null &&
          <NhiemVuTTXM
            donViGiaoThamTraXacMinh={dataDetail.donViGiaoThamTraXacMinhInfo}
            ngayBatDauTTXM={dataDetail.ngayBatDauTTXM}
            yKienCuaDonViGiaoTTXM = {dataDetail.yKienCuaDonViGiaoTTXM}
            ngayHetHanTTXM={dataDetail.ngayHetHanTTXM}
            donInfo = {this.props.donInfo}
          />
        }
        {
          dataDetail.donViGiaoThamTraXacMinhInfo != null &&
            <div className="wrap-big-line pt5 pb15">
              <span className="big-border"></span>
            </div>
        }
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={dataDetail}/>

        <div className="row pl15 pr15">
          {
            dataDetail.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' &&
            <BlockBanHanhQuyetDinhView donInfo={this.props.donInfo} thongTinGQD={dataDetail} dataKetLuanNoiDungKhieuNai={this.props.dataKetLuanNoiDungKhieuNai}/>
          }

            <div className="col-100 mt5 no-gutter">
              <h2 className="title-14 mb10">Thông tin giải quyết</h2>
            </div>

          <ShowIf condition={this.state.dataCongChuc.length > 0}>
            <div className='row pl10 pr10'>
              <DropDownMulipleUse
                className='col-25'
                label='Giao xử lý'
                onRef={select => (this.select = select)}
                onChange={this.onChange.bind(this, 'nextState')}
                selectedValue={nextState}
                data={this.state.dataNextStates}
                keyName='type'
                valueName='tenVietTat'
                require
                name='huongXuLyTheoDoiThucHien'
                confirm = {true}
                bindValidator={this}/>
              <ShowIf condition={nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || nextState == 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO'}>
                <DropDownChonCanBoGiaiQuyet
                  isValid={this.state.validate}
                  selectedValue={this.state.canBoXuLyChiDinh}
                  require
                  coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                  vaiTro='CHUYEN_VIEN'
                  bindValidator={this}
                  className="col-25"
                  label="Công chức giải quyết"
                  onChange={this.onChange.bind(this, 'canBoXuLyChiDinh')}
                  name="DropDownChonCanBoGiaiQuyet"
                />
                <TextArea className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" value={this.state.yKienGiaiQuyet} onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaCanBoKetLuanNoiDung"/>
              </ShowIf>

              <ShowIf condition={nextState == 'NHANTDTH_GIAO_PHONG_CUNG_CAP'}>
                <DropDownChonPhongBanThuocCoQuan
                  require
                  bindValidator={this}
                  selectedValue={this.state.phongBanChiDinh}
                  isValid={this.props.validate}
                  onChange={this.onChange.bind(this, 'phongBanChiDinh')}
                  name="dropdownChonPhongBanThuocCoQuan" />
              </ShowIf>

             {/* <ShowIf condition={this.state.phongBanChiDinh != '' && nextState == "NHANTDTH_GIAO_PHONG_CUNG_CAP"}>
                <DropDownChonCanBoGiaiQuyet
                  isValid={this.state.validate}
                  selectedValue={this.state.canBoGiaiQuyet}
                  require
                  coQuanQuanLyId={this.state.phongBanChiDinh}
                  vaiTro="TRUONG_PHONG"
                  bindvaiTroValidator={this}
                  className="col-25"
                  label="Lãnh đạo phòng"
                  onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                  name="dropdownChonCanBoGiaiQuyet"
                />
              </ShowIf> */}

              <ShowIf condition={nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG'}>
                <DropDownChonCanBoGiaiQuyet
                  isValid={this.state.validate}
                  selectedValue={this.state.canBoXuLyChiDinh}
                  require
                  coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                  vaiTro='PHO_PHONG'
                  bindValidator={this}
                  className="col-25"
                  label="Chọn phó phòng"
                  onChange={this.onChange.bind(this, 'canBoXuLyChiDinh')}
                  name="DropDownChonCanBoGiaiQuyet"
                />
              </ShowIf>
            </div>
          </ShowIf>
          {
            dk1 &&
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">{labelQD}</h3>
          }
          { /*Block edit thong tin quyet dinh giai quyet*/
            (dk1 && this.props.loaiDon == 'DON_KHIEU_NAI') &&
            <div className="row pl10 pr10">
              <ShowIf condition={this.state.soLanGiaiQuyetLai > 1}>
                <DropDownChonKetQuaGiaiQuyet className='col-25' name="ketQuaGiaiQuyetLan2" require bindValidator={this} label='Kết quả giải quyết' selectedValue={this.state.ketQuaGiaiQuyetLan2} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetLan2')}/>
              </ShowIf>
              <ShowIf condition={this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I' && (Number(this.state.soLanGiaiQuyetLai) > 1)}>
                <TextArea className='col-100' label='Lý do' require bindValidator={this} channel='formTaoDon' value={this.state.noiDungKetLuanGiaiQuyetLai} onChange={this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai')} name="noiDungKetLuanGiaiQuyetLai" maxLength={1000}/>
              </ShowIf>
            </div>
          }
          {
            dk1 &&
            <div className="row pl10 pr10">
              <InputNumber className="col-25 mb0-18" label="Số vụ" name="soVu" value={this.state.soVuGiaiQuyetKhieuNai} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')}/>
              <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.props.loaiDon} label={ketLuanNDKhieuNaiLabel} className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
              <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
            </div>
          }
          {
            dk1 &&
            <div className="row pl10 pr10">
              <div className="col-50 no-gutter mb20">
                <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                <Input className="col-50 mb0-18" type="sdt" name="tienPhaiThuNhaNuocQDGQ" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')}/>
                <Input className="col-50 mb0-18" type="sdt" align="right" name="datPhaiThuNhaNuocQDGQ" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')}/>
              </div>
              <div className="col-50 no-gutter mb20">
                <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                <Input className="col-50 mb0-18" type="sdt" align="right" name="tienPhaiTraCongDanQDGQ" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')}/>
                <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" name="datPhaiTraCongDanQDGQ" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')}/>
              </div>
              <div className="col-100 no-gutter">
                <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                <InputNumber className="col-25" name="tongSoNguoiXuLyHanhChinh" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')}/>
                <InputNumber className="col-25" name="soNguoiDaBiXuLyHanhChinh" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')}/>
                <InputNumber className="col-25" name="soNguoiDuocTraLaiQuyenLoi" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')}/>
              </div>
            </div>
          }
          {
            dk1 &&
            <div className="wrap-big-line pt5 pb15">
              <span className="big-border"></span>
            </div>
          }
          {/*block xử lý*/}

          <ShowIf condition={nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO'}>
            <div className="col-100 no-gutter mt5">
              <h2 className="title-14 mb15">Theo dõi thực hiện</h2>
            </div>
            <div className="col-100 no-gutter pt5 pb15">
              <span className="line-border"></span>
            </div>
          </ShowIf>


          <ShowIf condition={(nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') && (dataDetail.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || dataDetail.ketQuaXLDGiaiQuyet == 'DANG_TDTH')}>
            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter mt5 pb20">
                <h2 className="title-12">Nội dung Theo dõi thực hiện</h2>
                <div className="row pl10 pr10 mb20">
                  <ShowIf condition={this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI'}>
                    <DropDownMulipleUse className="col-25 mb0-18" label="Cơ quan theo dõi" bindValidator={this} selectedValue={this.state.coQuanTheoDoi} onChange={this.onChange.bind(this, 'coQuanTheoDoi')} name='coQuanTheoDoi' data={this.state.dataCoQuanTheoDoi} keyName='giaTri' valueName='ten'/>
                  </ShowIf>
                </div>
                <div className="row pl10 pr10 mb20">
                  <DropDownChonKetQuaThucHien className="col-25 mb0-18" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.ketQuaThucHienTheoDoi} onChange={this.onChange.bind(this, 'ketQuaThucHienTheoDoi')}/>
                  <Input className="col-25 mb0-18" label="Kết quả thực hiện khác" value={this.state.ketQuaThucHienKhac} onChange={this.onChange.bind(this, 'ketQuaThucHienKhac')} name='ketQuaThucHienKhac'/>
                </div>
                <div className="row pl10 pr10">
                  <div className="col-100 no-gutter mb20">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuoc')} name="tienPhaiThuTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuoc')} name="datPhaiThuTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu tiền (đ)" value={this.state.tienDaThuNhaNuoc} onChange={this.onChange.bind(this, 'tienDaThuNhaNuoc')} name="tienDaThuTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu đất (m2)" value={this.state.datDaThuNhaNuoc} onChange={this.onChange.bind(this, 'datDaThuNhaNuoc')} name="datDaThuTheoDoiThucHien"/>
                  </div>
                  <div className="col-100 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDan} onChange={this.onChange.bind(this, 'tienPhaiTraCongDan')} name="tienPhaiTraTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDan} onChange={this.onChange.bind(this, 'datPhaiTraCongDan')} name="datPhaiTraTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả tiền (đ)" value={this.state.tienDaTraCongDan} onChange={this.onChange.bind(this, 'tienDaTraCongDan')} name="tienDaTraTheoDoiThucHien"/>
                    <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả đất (m2)" value={this.state.datDaTraCongDan} onChange={this.onChange.bind(this, 'datDaTraCongDan')} name="datDaTraTheoDoiThucHien"/>
                  </div>
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={(nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO') && this.state.showFile}>
            <div className="col-100 pb5 no-gutter">
              <ContainerFileDinhKem
                name="GiaoCQDT"
                label="Danh sách văn bản xử lý"
                bindValidator={this}
                dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView}
                data={this.state.listTaiLieuVanThuGiaiQuyetDon}
                onSave={this.state.onSave}
                onFileRemove={this.onFileRemove.bind(this)}
                onFileChange={this.onFileChange.bind(this)}
              />
            </div>
          </ShowIf>
          <ShowIf condition={nextState != 'CAN_BO_TDTH_LUU_DON' && nextState != 'CAN_BO_PHONG_TDTH_LUU_HO_SO' && this.state.showFile}>
            <div className="col-100 pb5 no-gutter">
              <ContainerFileDinhKem name="GiaoCQDT" label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
            </div>
          </ShowIf>
          <ShowIf condition={!dataDetail.boSungThongTin && (dataDetail.noiDungBoSungHoSo != '' && dataDetail.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(dataDetail.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} dataShow={dataDetail.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
          <ShowIf condition={dataDetail.lanhDaoView != true && !dataDetail.boSungThongTin}>
            <div className="box-bottom gqd-wrap col-100 no-gutter">
              <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <ShowIf condition={nextState == 'CAN_BO_TDTH_LUU_DON' || nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO'}>
                <Link style={{right: 0, top: 'auto'}} className={`right btn-action btn-complete action-todo ${this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-disable" : 'btn-loading-inline') : ''}`} onClick={this.openDialog.bind(this, 'openDialog')}><span>Lưu hồ sơ</span></Link>
              </ShowIf>
              <ShowIf condition={nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || nextState == 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO' || nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' || nextState === 'NHANTDTH_GIAO_PHONG_CUNG_CAP'}>
                <Link style={{right: 0, top: 'auto'}} className={`right btn-action btn-move action-todo ${this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-disable" : 'btn-loading-inline') : ''}`} onClick={this.handleKetThuc.bind(this)}><span>Giao việc</span></Link>
              </ShowIf>
              <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this, 'openDialog')} onSuccess={this.onSuccess.bind(this)} title="Xác nhận lưu hồ sơ" content="Bạn có muốn lưu hồ sơ này?"/>
              <ConfirmDialog open={this.state.confirm} onClose={this.closeDialog.bind(this, 'confirm')} onSuccess={this.onConfirm.bind(this)} title="Xác nhận" content={msg.confirmChange}/>
            </div>
          </ShowIf>
        </div>
      </section>
    );
  }
}

TruongPhongNhanYeuCauTheoDoiThucHien.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  dataDetail: [],
  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon,
  }
}

export default connect(bindStateToProps)(TruongPhongNhanYeuCauTheoDoiThucHien);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/TruongPhongNhanYeuCauTheoDoiThucHien.jsx